import React, { useEffect, useRef } from "react";
import { App, Spin } from "antd";
import ActionButton from "../../../../masterComponents/actionButton";
import type { ColumnsType } from "antd/es/table";
import { useTabsContext } from "../../../../../contexts/tabsContext";
import { StyledTableItemLink } from "./styles/examplesAttrAnalyserTable.style";
import { StyledSourceValuesTableWrapper, StyledTable, StyledValue } from "../../analysisAgent.style";
import { useFetchData as usePagination } from "../../../../../hooks/useFetch/pagination";
import { useCommonPropertiesContext } from "../../../../../contexts/commonPropertiesContext";
import { SpinWrapper } from "../../../../../app/app.style";
import { LoadingOutlined } from '@ant-design/icons';
import { useAnalysisAgentContext } from "../../_analysisAgentContext";
import type { IExamplesManyData } from "../../UseFetchType";
import SourceTag from "../../../../masterComponents/SourceTag";

const ExamplesAttrAnalyzerTable: React.FC = () => {

	const { message: messageApi } = App.useApp();

	const { activeBatch, attributeToAnalyze, parentRowExamplesParams } = useAnalysisAgentContext();
	const { setId, setActiveTabKey } = useTabsContext();
	const { currentBatch, setChoosedBatchToQA } = useCommonPropertiesContext();

	const [fetchExamplesMany, {
		isLoading: isLoadingExamplesManyData,
		data: examplesManyData,
		page,
		totalRows: examplesTableTotalRows,
		error: examplesManyError,
		loadMore: examplesManyLoadMore,
		clearError: clearExamplesManyError
	}] = usePagination<IExamplesManyData[]>({
		optionalArray:[parentRowExamplesParams?.hash, parentRowExamplesParams?.targetTable],
		query: "/@batch/statistics/attributes/@attributeName/examples",
		selectData: (data: { items?: IExamplesManyData[] | null }) => (data?.items ?? []).map((example) => {
			const description = example.description;
			let _description = "";

			return {
				id: example._id,
				tag: example.tag,
				class: example.class_name,
				description: _description.length > 0 ? _description : description,
				value: example.value,
				source: example.source,
			};
		}),
		selectPageInfo: (data) => data.page_info
	})

	useEffect(() => {
		if (examplesManyError) {
			messageApi.error(examplesManyError.message);
			clearExamplesManyError?.();
		}
	}, [examplesManyError, messageApi]);

	const examplesTableRef = useRef(null);

	useEffect(() => {
		if (parentRowExamplesParams?.hash && parentRowExamplesParams?.targetTable) {
			const batch = parentRowExamplesParams.targetTable === "parent" ? currentBatch : activeBatch;
			setChoosedBatchToQA(batch);
			fetchExamplesMany(
				{ batch, attributeName: attributeToAnalyze },
				{ hashes: [parentRowExamplesParams.hash] }
			);
		}
	}, [parentRowExamplesParams?.hash, parentRowExamplesParams?.targetTable]);

	useEffect(() => {
		if (examplesManyData?.length) {
			const y = examplesTableRef.current.getBoundingClientRect().top + window.scrollY - 64 - 16;
			window.scrollTo({ top: y, behavior: "smooth" });
		}
	}, [examplesManyData]);

	const columns: ColumnsType = [
		{
			title: "Tag",
			dataIndex: "tag",
			render: (tag) => (
				// <EntityLinksDropdown material={tag} children={<StyledTableItemLink><a>{tag}</a></StyledTableItemLink>} />
				<p>{tag}</p>
			),
		},
		{
			title: "Classification",
			dataIndex: "class",
		},
		{
			title: "Tag Description",
			dataIndex: "description",
			render: (description) => <span dangerouslySetInnerHTML={{ __html: description }} />,
		},
		{
			title: "Characteristic Value",
			dataIndex: "value",
			render: (value) => <StyledValue>{value}</StyledValue>,
		},
		{
			title: "Source",
			dataIndex: "source",
			render: (source) => <SourceTag source={source} text={source.toUpperCase()} />,
		},
		{
			title: "Actions",
			key: "actions",
			dataIndex: "actions",
			render: (_: any, record) => (
				<StyledTableItemLink>
					{/* <a onClick={(e) => { e.preventDefault(); }}>Annotate</a> */}
					<a onClick={(e) => {
						e.preventDefault();
						setId(record.id);
						setActiveTabKey("QAManager");
					}}>QA</a>
				</StyledTableItemLink>
			)
		},
	];

	return (
		<>
			<SpinWrapper>
				<Spin
					indicator={<LoadingOutlined />}
					spinning={isLoadingExamplesManyData}
				/>
			</SpinWrapper>

			<StyledSourceValuesTableWrapper ref={examplesTableRef}>
				<StyledTable
					className="primary-table"
					tableLayout="auto"
					rowKey="id"
					columns={columns}
					dataSource={examplesManyData ?? []}
					onChange={(pagination) => {
            			if (pagination.current !== page) {
              				examplesManyLoadMore(pagination.current)
           				}
        			}}
					pagination={{
						current: page,
						pageSize: 15,
						total: examplesTableTotalRows,
						showSizeChanger: false,
						showTotal: () => (
							<>
								<ActionButton text="Apply search" className="primary-btn-color" disabled />
								<ActionButton text="Clear" className="primary-btn-color"
									//  onClick={clearSelectedKeys} 
									disabled
								/>
							</>
						),
					}}
				// rowSelection={{
				// 	type: "checkbox",
				// 	selectedRowKeys: selectedRowKeys,
				// 	  onChange: (keys) => setSelectedRowKeys(keys),
				// }}
				/>
			</StyledSourceValuesTableWrapper>
		</>
	);
}

export default ExamplesAttrAnalyzerTable;